import { isSeasonActive } from "../config/seasons";

export const category = [
  {
    id: 1,
    category_name: "Incense Sticks",
    slug: "incense-sticks",
    subCat: [
      {
        id: 11,
        category_name: "Zipper",
      },
      {
        id: 12,
        category_name: "Bundle 250 gm",
      },
      {
        id: 13,
        category_name: "Box",
      },
      {
        id: 14,
        category_name: "Jar 100gm",
      },
      {
        id: 15,
        category_name: "Jar 250gm",
      },
    ],
    quantity: "23 Fragrances Available",
    img: "../assets/nt/isticks.jpg",
  },
  {
    id: 2,
    category_name: "Dhoop Sticks",
    slug: "dhoop-sticks",
    subCat: [
      {
        id: 21,
        category_name: "Jar",
      },
      {
        id: 12,
        category_name: "Box",
      },
    ],
    quantity: "23 Flavors Available",
    img: "../assets/nt/sticks.jpg",
  },
  {
    id: 3,
    category_name: "Dhoop Cone",
    slug: "dhoop-cone",
    quantity: "9 Fragrances Available",
    img: "../assets/nt/cone-sandal.jpg",
    imgFit: "",
    subCat: [
      {
        id: 21,
        category_name: "Jar",
      },
      {
        id: 12,
        category_name: "Box",
      },
    ],
  },
  {
    id: 4,
    category_name: "Sambrani Cup",
    slug: "sambrani-cup",
    quantity: "Black & Cow Dung Cups",
    subCat: [
      {
        id: 41,
        category_name: " 10pc Box",
      },
      {
        id: 42,
        category_name: "12pc Box",
      },
      {
        id: 41,
        category_name: " 25pc Jar",
      },
    ],
    img: "../assets/nt/cups.jpg",
  }
];

export const blog_title="Celebrate with Color: The Rise of Eco-friendly Ganesh Idols for Ganesh Chaturthi"
export const blog_desc="Explore the significance of color in Ganesh Chaturthi celebrations and discover NT Sticks eco-friendly Ganesh idols made from clay, available in vibrant colors, and accompanied by a free Choki."

export const nav = [
  {
    path: "/",
    text: "Home",
  },
  {
    path: "/shop",
    text: "Shop",
  },
  {
    path: "/wholesale",
    text: "Wholesale",
  },
  {
    path: "/contact",
    text: "Contact",
  },
];

/**
 * Season switches now live in src/config/seasons.js (dates + manual override).
 * These are kept as named exports so existing imports keep working — edit the
 * config file, not these lines.
 */
export const GANESH_SEASON_ENABLED = isSeasonActive("ganesh");
export const DIWALI_SEASON_ENABLED = isSeasonActive("diwali");

export const topdropdown = [
  {
    id: 1,
    btn: "My Account",
  },

  {
    id: 3,
    btn: "USD",
  },
  {
    id: 2,
    btn: "EN",
  },
];
export const blogs_show_more = [
  {
    season: "ganesh",
    id:1,
    que: "Why Eco-Friendly Ganesh Idols Are Important for Ganesh Chaturthi ?",
    ans: "Ganesh Chaturthi, one of India's most beloved festivals, gathers communities together to commemorate the birth of Lord Ganesha, ",
  },

  {
    season: "ganesh",
    id:2,
    que: "The Environmental Impact of Traditional Ganesh Idols",
    ans: "Traditionally, plaster of Paris (PoP), which is not only non-biodegradable but also detrimental to aquatic life, ",
  },
  {
    season: "ganesh",
    id:3,
    que: "Cultural Significance Meets Environmental Responsibility",
    ans: "Selecting an eco-friendly Ganesh idol is a method to respect Lord Ganesha's very nature as well as demonstrate environmental responsibility.",
  },
  {
    season: "ganesh",
    id:4,
    que:"How You Can Make a Difference This Ganesh Chaturthi",
    ans:"As we prepare for Ganesh Chaturthi, let’s consider the impact of our choices. Opting for an eco-friendly Ganesh idol is a simple yet powerful way to reduce our environmental footprint When you choose an idol made from natural materials, "

  }
];
export const blogs = [
  {
    season: "ganesh",
    id:1,
    que: "Why Eco-Friendly Ganesh Idols Are Important for Ganesh Chaturthi ?",
    ans: "Ganesh Chaturthi, one of India's most beloved festivals, gathers communities together to commemorate the birth of Lord Ganesha, the remover of obstacles and the bringer of fresh beginnings. The festival's core is embodied in the colorful processions, devotional singing, and the installation of exquisitely made idols. The effects of these festivities on the environment have, however, come under investigation recently. Because Ganesh idols made of non-biodegradable materials have sparked worries about pollution, there is a rising push to replace them with environmentally friendly options.",
  },

  {
    season: "ganesh",
    id:2,
    que: "The Environmental Impact of Traditional Ganesh Idols",
    ans: "Traditionally, plaster of Paris (PoP), which is not only non-biodegradable but also detrimental to aquatic life, has been used to make Ganesh idols. At the conclusion (Ganpati Visarjan) of the celebration, these Ganesh idols are submerged in water, but they don't dissolve quickly, which pollutes the water. Heavy elements like lead and mercury are present in the chemical paints used to decorate these idols, further poisoning the water and endangering marine ecosystems.<br /> On the other hand, natural clay, paper mache, or other biodegradable materials are used to create eco-friendly Ganesh idols. These idols don't hurt the environment because they dissolve quickly in water. Additionally, natural colors are a safer option for the environment and the marine life who utilize them because they ensure that no harmful elements are emitted during the visarjan.",
  },
  {
    season: "ganesh",
    id:3,
    que: "Cultural Significance Meets Environmental Responsibility",
    ans: "Selecting an eco-friendly Ganesh idol is a method to respect Lord Ganesha's very nature as well as demonstrate environmental responsibility. The wisdom god Ganesha would undoubtedly support initiatives aimed at safeguarding and maintaining the environment that provides us with life. We connect our festivities with the principles of reverence and regard for all living things by adopting eco-friendly techniques.<br /> The trend for eco-friendly idols also gives an opportunity to help local artists who craft these idols by hand with traditional techniques that have been handed down through the years. This preserves the festival's cultural legacy in addition to being the helping hand to support their livelihood",
  },
  {
    season: "ganesh",
    id:4,
    que:"How You Can Make a Difference This Ganesh Chaturthi",
    ans:"As we prepare for Ganesh Chaturthi, let’s consider the impact of our choices. Opting for an eco-friendly Ganesh idol is a simple yet powerful way to reduce our environmental footprint When you choose an idol made from natural materials, you contribute to a cleaner environment and a more sustainable future.<br /> But why stop at just the idol? This year, you can take your commitment to the environment a step further with NT Sticks’ specially curated Eco-friendly Ganesh Kit. Our kit includes everything you need for a 10-day Ganesh Pooja, thoughtfully designed to minimize environmental impact. The kit contains an eco-friendly Ganesh idol, Sambrani cups, Dhoop sticks, Chooki, Red Cloth, Kalash, and Pooja Samagri—all made with the highest quality, natural ingredients.<br /> By choosing our Ganesh Kit, you not only simplify your preparations but also ensure that your celebration is in harmony with nature. Let’s celebrate Ganesh Chaturthi with a sense of responsibility and devotion, knowing that we are leaving a positive legacy for future generations. Embrace eco-friendly practices, support sustainable products, and let the blessings of Lord Ganesha guide us towards a greener, more mindful world."

  },
  {
    season: "ganesh",
    id:5,
    que: "Celebrating Ganesh Chaturthi with a Splash of Color: The Rise of Eco-Friendly Ganesh Idols",
    ans: "Ganesh Chaturthi, a festival that fills homes with joy, devotion, and color, brings families together to celebrate Lord Ganesha, the deity of wisdom and prosperity. Traditionally, this celebration is marked by the installation of a beautifully crafted Ganesh idol, adorned in vibrant colors and surrounded by flower, sweet, and incense offerings. However, as people become more aware of environmental issues, they are looking for new ways to celebrate this festival that honors both tradition and nature. This has led to a rise in the popularity of eco-friendly Ganesh idols, which not only uphold the spiritual essence of the festival but also contribute to a healthier planet.",
  },

  {
    season: "ganesh",
    id:6,
    que: "The Significance of Color in Ganesh Chaturthi Celebrations",
    ans: "An essential part of Indian philosophy and culture are colours. Every colour has a unique symbolic meaning and energy that affects the ambience of the area where the idol is placed. For example, the colour red stands for strength and power, and the colour yellow for study and knowledge—qualities that are intimately related to Lord Ganesha. In addition to adding to the celebrations' aesthetic appeal, a brightly coloured Ganesh idol also corresponds with the spiritual vibrations you are trying to activate. The deliberate use of chemical paints to Ganesh idols has historically presented a serious environmental risk. These paints frequently include dangerous ingredients that, when dissolved in water, can pollute the water, endangering ecosystems and aquatic life. Natural clay Ganesh idols that are dyed with organic colours provide a colourful, sustainable, and environmentally friendly substitute.",
  },
  {
    season: "ganesh",
    id:7,
    que: "Why Choose an Eco-friendly Ganesh Idol?",
    ans: "Eco-friendly Natural clay, which is both biodegradable and has great spiritual importance, is used to manufacture Ganesh idols. By representing the Earth itself, clay grounds the idol in the natural world. These idols disintegrate readily in water, leaving no pollution residue behind. By doing this, you can celebrate Ganesh Chaturthi in a way that respects the environment and expresses your devotion without sacrificing your moral principles. Additionally, purchasing an eco-friendly idol helps support regional craftspeople who create these idols by hand using age-old techniques. Your purchase supports the continuation of these cultural traditions, as idol-making has been a family craft in many of the areas from which these artists hail.",
  },
  {
    season: "ganesh",
    id:8,
    que:"Adding a Personalized Touch to Your Celebrations",
    ans:"The option to select from a range of colours that speak to your own sense of spirituality and style is what distinguishes eco-friendly Ganesh idols. There is an eco-friendly Ganesh idol to fit every taste, whether you like the energetic feelings of red and yellow or the soothing tones of blue and green. This gives you the opportunity to personalize your Ganesh Chaturthi celebration and make it a representation of your distinct commitment and flair.<br/> We at NT Sticks are pleased to provide an assortment of Eco-friendly Ganesh Idols, which are made from natural clay and come in a variety of hues. A free Choki is included with every idol, which will add an extra touch of tradition to your holiday preparations. Selecting one of our environmentally friendly idols will not only make your house look better, but it will also help to protect the environment.<br/> Make the decision to celebrate Ganesh Chaturthi with an <a style='color: rgb(72, 225, 72)' href='/item/Eco_Friendly_Ganesh_Kit'>eco-friendly Ganesh idol</a> this year. Allow your love to be shown in eco-friendly hues, and allow Lord Ganesha's blessings to lead you to a more peaceful and sustainable way of life."

  }


];
export const socialIcon = [
  {
    icon: <i className="fab fa-instagram"></i>,
    name: "instagram",
    link: "https://www.instagram.com/ntsticks",
  },
  {
    icon: <i className="fab fa-facebook-f"></i>,
    name: "facebook",
    link:"https://www.facebook.com/people/NT-Sticks/61562741386886/"
  },
  {
    icon: <i class="fab fa-amazon"></i>,
    name: "Amazon",
    link:"https://www.amazon.in/s?k=ACHHARI PERFUMERY WORKS"

  },
  {
    icon: <i className="fab fa-youtube"></i>,
    name: "youtube",
    link: "https://www.youtube.com/@ntsticks",
  },
  
];


export const ganesh={
    id: 0,
    product_name:"Eco-Friendly Ganesh Idol Made of Clay with Free Chouki, Mala, 100g Dhoop Stick, and Red Cloth - Perfect for Ganesh Chaturthi",
    product_name_key:"Eco_Friendly_Ganesh_Kit",
    product_name_detail: "Eco-Friendly Ganesh Idol Made of Clay with Free Chouki, Mala, 100g Dhoop Stick, and Red Cloth - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/nt/ganesh12.jpg",
      price: "999",
      mainPrice: "1499",
      weight: "1500",
      fragranceNotes: {
        top: ["Sandalwood", "Lemon Peel", "Lavender"],
        middle: ["Rosewood", "Patchouli", "Musk"],
        base: ["Amber", "Cedar", "Spice"],
      },
      badges: ["Natural Clay Idol", "Complete Puja Kit", "Biodegradable", "Direct from Factory"],
      description:
        "Celebrate the auspicious festival of Ganesh Chaturthi with our eco-friendly Ganesh idols, crafted with love and respect for nature. These Ganesh clay idols are made from natural, biodegradable materials like clay, ensuring minimal harm to the environment. By choosing an eco-friendly Ganesh idol, you not only honor Lord Ganesha but also contribute to preserving our planet for future generations.These idols are designed with intricate details, capturing the essence of Indian culture and tradition. \nWhether you plan to immerse the idol in water or perform an eco-friendly immersion at home, our eco-friendly Ganpati idols are a sustainable choice that aligns with the principles of Dharma. Embrace the joy of the festival while being mindful of our planet's well-being.\nBring home an eco-friendly Ganesh idol and experience the divine blessings of the remover of obstacles while doing your part for the environment. Celebrate with our eco-friendly Ganesh Chaturthi idols and enjoy a greener, more responsible festival.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Eco-friendly Ganesh Kit",
      meta_description:"The Diwali hamper is a beautifully curated collection of items that combine festive decor, health-conscious snacks, chocolates, and relaxing elements like incense and candles. It’s designed to bring together the spirit of Diwali through decor, treats, and meaningful gifting, offering both indulgence and celebration essentials.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/nt/ganesh.jpg",
          url_l: "../assets/nt/ganesh.jpg",
        },
        {
          id: 1,
          url_s: "../assets/nt/ganesh1.jpg",
          url_l: "../assets/nt/ganesh1.jpg",
        },
        {
          id: 2,
          url_s: "../assets/nt/ganesh2.jpg",
          url_l: "../assets/nt/ganesh2.jpg",
        },
        {
          id: 3,
          url_s: "../assets/nt/ganesh4.jpg",
          url_l: "../assets/nt/ganesh4.jpg",
        },
       
      ]
    
}
export const products = [
  {
    id: 0,
    product_name:"Eco-Friendly Ganesh Kit",
    product_name_key:"Eco_Friendly_Ganesh_Kit",
    product_name_detail: "Eco-Friendly Ganesh Kit",
    isGaneshSeasonal: true,
      product_img: "../assets/nt/ganesh.jpg",
      price: "999",
      mainPrice: "1499",
      weight: "1500",
      description:
        "The Eco-Friendly Ganesh Kit brings together everything a household needs to set up and honour Ganpati at home, in one box. At its centre is a Ganesh idol hand-shaped from natural clay - fully biodegradable, finished in natural colours, and made to dissolve cleanly at visarjan rather than leave plaster and chemical paint behind in the water. Alongside the idol the kit includes a chouki to seat him on, a mala, a red cloth, and 100g of our own dhoop sticks so the fragrance of the puja comes from the same factory as the idol. It is assembled for people who want to keep the ritual complete without sourcing each piece separately, and who would rather their celebration left nothing behind. Made in Indore, packed to arrive intact, and priced as a kit rather than as five separate purchases.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Eco-friendly Ganesh Kit",
      meta_description:"A complete eco-friendly Ganesh Chaturthi kit: natural clay Ganesh idol with chouki, mala, red cloth and 100g NT Sticks dhoop. Fully biodegradable, made in Indore.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/nt/ganesh-kit.jpg",
          url_l: "../assets/nt/ganesh-kit.jpg",
        },
        {
          id: 1,
          url_s: "../assets/nt/ganesh1.jpg",
          url_l: "../assets/nt/ganesh1.jpg",
        },
        {
          id: 2,
          url_s: "../assets/nt/ganesh2.jpg",
          url_l: "../assets/nt/ganesh2.jpg",
        },
        {
          id: 3,
          url_s: "../assets/nt/ganesh4.jpg",
          url_l: "../assets/nt/ganesh4.jpg",
        },
       
      ],
    },
  {
    id: 1,
    product_name:"Diwali Hamper",
    product_name_key:"Diwali_Hamper",
    product_name_detail: "Diwali Hamper",
    isDiwaliSeasonal: true,
      product_img: "../assets/nt/diwali-complete-kit.jpg",
      price: "1699",
      mainPrice: "1499",
      weight: "1500",
      description:
        "The Diwali hamper is a beautifully curated collection of items that combine festive decor, health-conscious snacks, chocolates, and relaxing elements like incense and candles. It’s designed to bring together the spirit of Diwali through decor, treats, and meaningful gifting, offering both indulgence and celebration essentials.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Complete Diwali Hamper",
      meta_description:"The Diwali hamper is a beautifully curated collection of items that combine festive decor, health-conscious snacks, chocolates, and relaxing elements like incense and candles. It’s designed to bring together the spirit of Diwali through decor, treats, and meaningful gifting, offering both indulgence and celebration essentials.",
      gallery: [
        // {
        //   id: 0,
        //   url_s: "../assets/nt/ganesh-kit.jpg",
        //   url_l: "../assets/nt/ganesh-kit.jpg",
        // },
        // {
        //   id: 1,
        //   url_s: "../assets/nt/ganesh1.jpg",
        //   url_l: "../assets/nt/ganesh1.jpg",
        // },
        // {
        //   id: 2,
        //   url_s: "../assets/nt/ganesh2.jpg",
        //   url_l: "../assets/nt/ganesh2.jpg",
        // },
        // // {
        // //   id: 3,
        // //   url_s: "../assets/nt/ganesh3.jpg",
        // //   url_l: "../assets/nt/ganesh3.jpg",
        // // },
        // {
        //   id: 3,
        //   url_s: "../assets/nt/ganesh4.jpg",
        //   url_l: "../assets/nt/ganesh4.jpg",
        // },
       
      ],
  },
  {
    id: 2,
    product_name:"Natural Clay Ganesh – Pagdi",
    product_name_key:"Eco_Friendly_Ganesh_Ji_N5",
    product_name_detail: " 6 Inch Eco-Friendly Ganesh Idol Made of Clay with Free Chouki - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/idols/g1/0.webp",
      price: "299",
      mainPrice: "699",
      weight: "500",
      description:
        "This Ganesh murti is finished with a pagdi-style turban. The pagdi is the everyday crown of the Indian householder, and it gives this murti a warm, approachable presence rather than a regal one — a good fit for a home mandir or a first Ganpati. Like every idol we make, it is shaped from natural clay and nothing else — no plaster of Paris, no chemical paint on the unpainted pieces, and no additive that would keep it from breaking down. That matters at visarjan: PoP idols do not dissolve, and the ones that end up in a lake or a river stay there. Clay returns to the water it came from, which is what makes an immersion at home in a bucket or a drum a real option rather than a compromise. Every idol ships with a free chouki, a mala, a 100g dhoop stick pack and a red cloth, so it is ready for sthapana the day it arrives. Celebrate the festival fully and leave nothing behind that the water has to carry.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Eco-Friendly Clay Ganesh Idol - Pagdi | Free Chouki",
      meta_description:"Natural clay Ganesh idol in a pagdi turban — the householder's crown, warm rather than regal. ₹299 with free chouki, mala, dhoop and cloth.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/idols/g1/1.webp",
          url_l: "../assets/idols/g1/1.webp",
        },
        {
          id: 1,
          url_s: "../assets/idols/g1/2.webp",
          url_l: "../assets/idols/g1/2.webp",
        },
        {
          id: 2,
          url_s: "../assets/idols/g1/3.webp",
          url_l: "../assets/idols/g1/3.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g1/4.webp",
          url_l: "../assets/idols/g1/4.webp",
        },
       
      ],
  },
  {
    id: 3,
    product_name:"Hand-Painted Ganesh – Red Pagdi",
    product_name_key:"Eco_Friendly_Ganesh_Ji_C1",
    product_name_detail: " 6 Inch Eco-Friendly Ganesh Idol Made of Clay with Free Chouki - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/idols/g2/0.webp",
      price: "299",
      mainPrice: "699",
      weight: "500",
      description:
        "This Ganesh murti is finished with a hand-painted red pagdi. The red pagdi is painted by hand, so no two are identical, and red carries the festive charge that suits the first day of the festival. Under the paint it is the same natural clay as our unpainted idols. Like every idol we make, it is shaped from natural clay and nothing else — no plaster of Paris, no chemical paint on the unpainted pieces, and no additive that would keep it from breaking down. That matters at visarjan: PoP idols do not dissolve, and the ones that end up in a lake or a river stay there. Clay returns to the water it came from, which is what makes an immersion at home in a bucket or a drum a real option rather than a compromise. Every idol ships with a free chouki, a mala, a 100g dhoop stick pack and a red cloth, so it is ready for sthapana the day it arrives. Celebrate the festival fully and leave nothing behind that the water has to carry.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Hand-Painted Ganesh Idol - Red Pagdi | Eco-Friendly Clay",
      meta_description:"Hand-painted Ganesh idol in a red pagdi, painted individually so no two match. ₹299, natural clay, dissolves cleanly at visarjan.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/idols/g2/0.webp",
          url_l: "../assets/idols/g2/0.webp",
        },
        {
          id: 1,
          url_s: "../assets/idols/g2/1.webp",
          url_l: "../assets/idols/g2/1.webp",
        },
        {
          id: 2,
          url_s: "../assets/idols/g2/2.webp",
          url_l: "../assets/idols/g2/2.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g2/3.webp",
          url_l: "../assets/idols/g2/3.webp",
        },
       
      ],
  },
  {
    id: 4,
    product_name:"Natural Clay Ganesh – Darbar",
    product_name_key:"Eco_Friendly_Ganesh_Ji_N3",
    product_name_detail: " 6 Inch Eco-Friendly Ganesh Idol Made of Clay with Free Chouki - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/idols/g3/0.webp",
      price: "299",
      mainPrice: "699",
      weight: "500",
      description:
        "This Ganesh murti is finished with a seated darbar pose. The darbar pose shows Ganesha seated in court, the form associated with granting audience and removing obstacles — the most traditional of our shapes, and the one most families ask for. Like every idol we make, it is shaped from natural clay and nothing else — no plaster of Paris, no chemical paint on the unpainted pieces, and no additive that would keep it from breaking down. That matters at visarjan: PoP idols do not dissolve, and the ones that end up in a lake or a river stay there. Clay returns to the water it came from, which is what makes an immersion at home in a bucket or a drum a real option rather than a compromise. Every idol ships with a free chouki, a mala, a 100g dhoop stick pack and a red cloth, so it is ready for sthapana the day it arrives. Celebrate the festival fully and leave nothing behind that the water has to carry.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Eco-Friendly Clay Ganesh Idol - Darbar | Free Chouki",
      meta_description:"Natural clay Ganesh idol in the seated darbar pose — the most traditional form, and the one most families ask for. ₹299 with free puja kit.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/idols/g3/0.webp",
          url_l: "../assets/idols/g3/0.webp",
        },
        {
          id: 1,
          url_s: "../assets/idols/g3/1.webp",
          url_l: "../assets/idols/g3/1.webp",
        },
        {
          id: 2,
          url_s: "../assets/idols/g3/2.webp",
          url_l: "../assets/idols/g3/2.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g3/3.webp",
          url_l: "../assets/idols/g3/3.webp",
        },
       
      ],
  },
  {
    id: 5,
    product_name:"Natural Clay Ganesh – Jata Mukut",
    product_name_key:"Eco_Friendly_Ganesh_Ji_N1",
    out_of_stock:true,
    product_name_detail: " 6 Inch Eco-Friendly Ganesh Idol Made of Clay with Free Chouki - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/idols/g4/0.webp",
      price: "299",
      mainPrice: "699",
      weight: "500",
      description:
        "This Ganesh murti is finished with a jata mukut. The jata mukut, the matted-hair crown, links Ganesha to his father Shiva and gives this murti a more ascetic character than the jewelled crowns — quieter, and suited to a household that keeps the festival simply. Like every idol we make, it is shaped from natural clay and nothing else — no plaster of Paris, no chemical paint on the unpainted pieces, and no additive that would keep it from breaking down. That matters at visarjan: PoP idols do not dissolve, and the ones that end up in a lake or a river stay there. Clay returns to the water it came from, which is what makes an immersion at home in a bucket or a drum a real option rather than a compromise. Every idol ships with a free chouki, a mala, a 100g dhoop stick pack and a red cloth, so it is ready for sthapana the day it arrives. Celebrate the festival fully and leave nothing behind that the water has to carry.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Eco-Friendly Clay Ganesh Idol - Jata Mukut | Free Chouki",
      meta_description:"Natural clay Ganesh idol with a jata mukut, the matted-hair crown linking Ganesha to Shiva. ₹299, biodegradable, no plaster of Paris.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/idols/g4/0.webp",
          url_l: "../assets/idols/g4/0.webp",
        },
        {
          id: 1,
          url_s: "../assets/idols/g4/1.webp",
          url_l: "../assets/idols/g4/1.webp",
        },
        {
          id: 2,
          url_s: "../assets/idols/g4/2.webp",
          url_l: "../assets/idols/g4/2.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g4/3.webp",
          url_l: "../assets/idols/g4/3.webp",
        },
       
      ],
  },
  {
    id: 6,
    product_name:"Natural Clay Ganesh – Crown Mukut",
    product_name_key:"Eco_Friendly_Ganesh_Ji_N2P",
    product_name_detail: " 6 Inch Eco-Friendly Ganesh Idol Made of Clay with Free Chouki - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/idols/g5/0.webp",
      price: "299",
      mainPrice: "699",
      weight: "500",
      description:
        "This Ganesh murti is finished with a crown mukut. The crown mukut is the classic royal form, upright and formal. It reads well from a distance, which makes it a sensible choice if your Ganpati sits at the far end of a room or on a raised chouki. Like every idol we make, it is shaped from natural clay and nothing else — no plaster of Paris, no chemical paint on the unpainted pieces, and no additive that would keep it from breaking down. That matters at visarjan: PoP idols do not dissolve, and the ones that end up in a lake or a river stay there. Clay returns to the water it came from, which is what makes an immersion at home in a bucket or a drum a real option rather than a compromise. Every idol ships with a free chouki, a mala, a 100g dhoop stick pack and a red cloth, so it is ready for sthapana the day it arrives. Celebrate the festival fully and leave nothing behind that the water has to carry.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Eco-Friendly Clay Ganesh Idol - Crown Mukut | Free Chouki",
      meta_description:"Natural clay Ganesh idol with a royal crown mukut — upright and formal, and readable from across a room. ₹299 with free chouki and mala.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/idols/g5/0.webp",
          url_l: "../assets/idols/g5/0.webp",
        },
        {
          id: 0,
          url_s: "../assets/idols/g5/1.webp",
          url_l: "../assets/idols/g5/1.webp",
        },
        {
          id: 1,
          url_s: "../assets/idols/g5/2.webp",
          url_l: "../assets/idols/g5/2.webp",
        },
        {
          id: 2,
          url_s: "../assets/idols/g5/3.webp",
          url_l: "../assets/idols/g5/3.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g5/4.webp",
          url_l: "../assets/idols/g5/4.webp",
        },
       
      ],
  },
  {
    id: 7,
    product_name:"Hand-Painted Ganesh – Blue Mukut",
    product_name_key:"Eco_Friendly_Ganesh_Ji_C3",
    product_name_detail: " 6 Inch Eco-Friendly Ganesh Idol Made of Clay with Free Chouki - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/idols/g6/0.webp",
      price: "299",
      mainPrice: "699",
      weight: "500",
      description:
        "This Ganesh murti is finished with a hand-painted blue mukut. The blue mukut is hand-painted over natural clay, cooler and more restrained than the red and gold finishes. Blue is unusual in Ganpati idols and stands out among a row of conventional ones. Like every idol we make, it is shaped from natural clay and nothing else — no plaster of Paris, no chemical paint on the unpainted pieces, and no additive that would keep it from breaking down. That matters at visarjan: PoP idols do not dissolve, and the ones that end up in a lake or a river stay there. Clay returns to the water it came from, which is what makes an immersion at home in a bucket or a drum a real option rather than a compromise. Every idol ships with a free chouki, a mala, a 100g dhoop stick pack and a red cloth, so it is ready for sthapana the day it arrives. Celebrate the festival fully and leave nothing behind that the water has to carry.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Hand-Painted Ganesh Idol - Blue Mukut | Eco-Friendly Clay",
      meta_description:"Hand-painted Ganesh idol with a blue mukut — cooler and more restrained than the red and gold finishes. ₹299, natural clay, safe for water visarjan.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/idols/g6/0.webp",
          url_l: "../assets/idols/g6/0.webp",
        },
        {
          id: 0,
          url_s: "../assets/idols/g6/1.webp",
          url_l: "../assets/idols/g6/1.webp",
        },
        {
          id: 1,
          url_s: "../assets/idols/g6/2.webp",
          url_l: "../assets/idols/g6/2.webp",
        },
        {
          id: 2,
          url_s: "../assets/idols/g6/3.webp",
          url_l: "../assets/idols/g6/3.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g6/4.webp",
          url_l: "../assets/idols/g6/4.webp",
        },
       
      ],
  },
  {
    id: 8,
    product_name:"Hand-Painted Ganesh – Gold Mukut",
    product_name_key:"Eco_Friendly_Ganesh_Ji_C2",
    product_name_detail: " 6 Inch Eco-Friendly Ganesh Idol Made of Clay with Free Chouki - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/idols/g7/0.webp",
      price: "299",
      mainPrice: "699",
      weight: "500",
      description:
        "This Ganesh murti is finished with a hand-painted gold mukut. The gold mukut is the most ornate finish we make, hand-painted over natural clay for households that want the idol to be the visual centre of the mandap. Like every idol we make, it is shaped from natural clay and nothing else — no plaster of Paris, no chemical paint on the unpainted pieces, and no additive that would keep it from breaking down. That matters at visarjan: PoP idols do not dissolve, and the ones that end up in a lake or a river stay there. Clay returns to the water it came from, which is what makes an immersion at home in a bucket or a drum a real option rather than a compromise. Every idol ships with a free chouki, a mala, a 100g dhoop stick pack and a red cloth, so it is ready for sthapana the day it arrives. Celebrate the festival fully and leave nothing behind that the water has to carry.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Hand-Painted Ganesh Idol - Gold Mukut | Eco-Friendly Clay",
      meta_description:"Hand-painted Ganesh idol with a gold mukut, the most ornate finish we make. ₹299, natural clay, dissolves cleanly at visarjan.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/idols/g7/0.webp",
          url_l: "../assets/idols/g7/0.webp",
        },
        {
          id: 0,
          url_s: "../assets/idols/g7/1.webp",
          url_l: "../assets/idols/g7/1.webp",
        },
        {
          id: 1,
          url_s: "../assets/idols/g7/2.webp",
          url_l: "../assets/idols/g7/2.webp",
        },
        {
          id: 2,
          url_s: "../assets/idols/g7/3.webp",
          url_l: "../assets/idols/g7/3.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g7/4.webp",
          url_l: "../assets/idols/g7/4.webp",
        },
        {
          id: 4,
          url_s: "../assets/idols/g7/5.webp",
          url_l: "../assets/idols/g7/5.webp",
        },

       
      ],
  },
  {
    id: 9,
    product_name:"Natural Clay Ganesh – Tall Mukut",
    product_name_key:"Eco_Friendly_Ganesh_Ji_N2M",
    product_name_detail: " 6 Inch Eco-Friendly Ganesh Idol Made of Clay with Free Chouki - Perfect for Ganesh Chaturthi",
    isGaneshSeasonal: true,
      product_img: "../assets/idols/g8/0.webp",
      price: "299",
      mainPrice: "699",
      weight: "500",
      description:
        "This Ganesh murti is finished with a tall mukut. The tall mukut gives this murti more height than the rest of the range without adding bulk, which helps when the idol has to hold its own against a decorated backdrop. Like every idol we make, it is shaped from natural clay and nothing else — no plaster of Paris, no chemical paint on the unpainted pieces, and no additive that would keep it from breaking down. That matters at visarjan: PoP idols do not dissolve, and the ones that end up in a lake or a river stay there. Clay returns to the water it came from, which is what makes an immersion at home in a bucket or a drum a real option rather than a compromise. Every idol ships with a free chouki, a mala, a 100g dhoop stick pack and a red cloth, so it is ready for sthapana the day it arrives. Celebrate the festival fully and leave nothing behind that the water has to carry.",
      stars: Array(5).fill(
        <small className="fa fa-star text-primary mr-1"></small>
      ),
      ratingCount: 99,
      meta_title:"Eco-Friendly Clay Ganesh Idol - Tall Mukut | Free Chouki",
      meta_description:"Natural clay Ganesh idol with a tall mukut — extra height without extra bulk, for a decorated mandap. ₹299 with free chouki, mala and dhoop.",
      gallery: [
        {
          id: 0,
          url_s: "../assets/idols/g8/0.webp",
          url_l: "../assets/idols/g8/0.webp",
        },
        {
          id: 0,
          url_s: "../assets/idols/g8/1.webp",
          url_l: "../assets/idols/g8/1.webp",
        },
        {
          id: 1,
          url_s: "../assets/idols/g8/2.webp",
          url_l: "../assets/idols/g8/2.webp",
        },
        {
          id: 2,
          url_s: "../assets/idols/g8/3.webp",
          url_l: "../assets/idols/g8/3.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g8/4.webp",
          url_l: "../assets/idols/g8/4.webp",
        },
        {
          id: 3,
          url_s: "../assets/idols/g8/5.webp",
          url_l: "../assets/idols/g8/5.webp",
        },
       
      ],
  },
  

  {
    id: 10,
    product_name: "Sandal Jar",
    category: "dhoop-sticks",
    product_name_key:"Sandal_Jar",
    product_img: "../assets/nt/jar/1.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Sandal Fragrance Dhoop Sticks bring the sacred and timeless aroma of sandalwood into your home, offering a fragrance that is both calming and spiritually uplifting. Sandalwood has been revered for centuries in religious and spiritual practices for its ability to center the mind and evoke a sense of peace. Our dhoop sticks are made from pure sandalwood, ensuring a consistent burn that releases the deep, woody scent of sandalwood into your space. This soothing aroma is perfect for meditation, prayer, or creating a tranquil environment where you can unwind and connect with your inner self. The fragrance of Sandal Dhoop Sticks is grounding and comforting, helping to purify your space and elevate your spiritual practices. Whether you are seeking to enhance your meditation or simply enjoy the sacred scent of sandalwood, these dhoop sticks provide a rich olfactory experience that nurtures the soul and fosters a peaceful atmosphere.",

    weight: "100",
    meta_title:"Sandal Dhoop Sticks - Sacred Sandalwood Aroma",
    meta_description:"Experience the sacred scent of Sandal Dhoop Sticks, crafted with sandalwood for a calming and spiritual atmosphere.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/jar/1.jpg",
        url_l: "../assets/nt/jar/1.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/1.jpg",
        url_l: "../assets/nt/jar/1.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/1.jpg",
        url_l: "../assets/nt/jar/1.jpg",
      },
    ],
  },
  {
    id: 12,
    product_name: "White Musk Jar",
    category: "dhoop-sticks",
    product_name_key:"White_Musk_Jar",
    product_img: "../assets/nt/jar/white-musk.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Indulge in the serene and luxurious aroma of White Musk Fragrance Dhoop Sticks, an exquisite blend of natural ingredients designed to elevate your spiritual and meditation practices. The rich, smooth fragrance of white musk envelops your senses, creating a tranquil ambiance perfect for relaxation or sacred rituals. Our dhoop sticks are crafted using traditional methods, ensuring that each stick burns evenly, releasing a long-lasting scent that lingers in your space. Whether you’re seeking peace after a long day or aiming to enhance your spiritual practices, White Musk Dhoop Sticks offer a unique olfactory experience that connects you with nature and divinity. Perfect for use during meditation, yoga, or simply to refresh your living space, these dhoop sticks provide an aromatic journey that soothes the mind and spirit.",

    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"White Musk Dhoop Sticks - Pure Fragrance Bliss",
    meta_description:"Experience the soothing aroma of White Musk Dhoop Sticks, crafted with natural ingredients for a serene and calming environment.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/jar/white-musk.jpg",
        url_l: "../assets/nt/jar/white-musk.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/white-musk.jpg",
        url_l: "../assets/nt/jar/white-musk.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/white-musk.jpg",
        url_l: "../assets/nt/jar/white-musk.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/white-musk.jpg",
        url_l: "../assets/nt/jar/white-musk.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/white-musk.jpg",
        url_l: "../assets/nt/jar/white-musk.jpg",
      },
    ],
  },
  {
    id: 13,
    product_name: "Hawan Jar",
    category: "dhoop-sticks",
    product_name_key:"Hawan_Jar",
    product_img: "../assets/nt/jar/3.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:"Hawan Fragrance Dhoop Sticks are crafted to bring the divine essence of traditional Hindu rituals into your home. Infused with sacred herbs and resins, these dhoop sticks evoke the sanctity of a hawan, a fire ritual meant to purify the environment and invite positive energies. Each stick is meticulously prepared to ensure a slow, even burn, releasing a rich and potent aroma that purifies the air and uplifts your spirit. Ideal for religious ceremonies, meditation, or daily prayers, Hawan Dhoop Sticks create a sacred space where you can connect with the divine. The earthy and soothing fragrance calms the mind, making it easier to focus and meditate. Whether you're conducting a full ritual or simply wishing to cleanse your space, these dhoop sticks offer an authentic experience of spiritual purity and tranquility.",
    weight: "100",
    meta_title:"Hawan Dhoop Sticks - Sacred Aroma for Rituals",
    meta_description:"Elevate your rituals with Hawan Dhoop Sticks, infused with sacred herbs and ingredients for a divine and purifying fragrance.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/jar/3.jpg",
        url_l: "../assets/nt/jar/3.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/3.jpg",
        url_l: "../assets/nt/jar/3.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/3.jpg",
        url_l: "../assets/nt/jar/3.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/jar/3.jpg",
        url_l: "../assets/nt/jar/3.jpg",
      },
      
    ],
  },
   {
    id: 14,
    product_name: "Kasturi",
    category: "dhoop-sticks",
    product_name_key:"Kasturi",
    product_img: "../assets/nt/kasturi.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Kasturi Fragrance Dhoop Sticks carry the deep, warm sweetness of musk, one of the oldest and most treasured notes in Indian perfumery. Kasturi has long been associated with devotion and ceremony, valued for an aroma that settles a room rather than sharpens it. Our dhoop sticks are made from natural ingredients and pressed to burn slowly and evenly, releasing a soft, powdery warmth that lingers well after the stick has finished. This grounding scent suits evening prayer, quiet reading, or any moment you want the house to feel still. Kasturi is gentle enough for daily use yet distinctive enough to be noticed, making it a favourite for those who prefer warmth over florals. Let the enveloping aroma of kasturi bring a sense of calm and quiet luxury to your home.",

    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Kasturi Dhoop Sticks - Uplifting Floral Delight",
    meta_description:"Kasturi dhoop sticks, 100g jar at ₹55. Deep, warm musk — one of the oldest notes in Indian perfumery. Bamboo-free and charcoal-free, made in Indore.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/kasturi.jpg",
        url_l: "../assets/nt/kasturi.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/kasturi.jpg",
        url_l: "../assets/nt/kasturi.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/kasturi.jpg",
        url_l: "../assets/nt/kasturi.jpg",
      },
      {
        id: 0,
        url_s: "../assets/nt/kasturi.jpg",
        url_l: "../assets/nt/kasturi.jpg",
      },
    ],
  },

  {
    id: 15,
    product_name: "Muskan Jar",
    category: "dhoop-sticks",
    product_name_key:"Muskan_Jar",
    product_img: "../assets/nt/jar/5.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Muskan Fragrance Dhoop Sticks in our resealable jar bring an uplifting floral aroma to everyday moments. 'Muskan' means smile in Hindi, and the blend is built to live up to it - bright, fresh and cheerful without ever turning heavy. Made from natural ingredients and pressed for a steady, even burn, each stick releases a clear floral note that carries through a room and fades softly. The jar keeps the sticks fresh and protected between uses, which makes this the practical format for a fragrance you reach for often. Light one to start the morning, to lift the mood of a shared space, or to welcome guests. Muskan Dhoop Sticks offer a simple, reliable way to make a room feel a little brighter.",

    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Muskan Dhoop Sticks Jar 100g - Uplifting Floral Dhoop",
    meta_description:"Muskan dhoop sticks in a resealable 100g jar. A bright floral blend, bamboo-free and charcoal-free, made at our Indore factory.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/jar/5.jpg",
        url_l: "../assets/nt/jar/5.jpg",
      }
    ],
  },
  {
    id: 16,
    product_name: "Oudh box",
    category: "dhoop-sticks",
    product_name_key:"Oudh_box",
    product_img: "../assets/nt/oudh_jar.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    weight: "100",
    description:
      "Oudh Fragrance Dhoop Sticks bring the deep, resinous character of agarwood - the most prized wood in traditional perfumery - into your home. Oudh is dark, woody and faintly sweet, a scent burned in ceremony across South Asia and the Middle East for centuries. Our dhoop sticks are crafted from natural ingredients and burn slowly and evenly, releasing a rich smokiness that fills a space without overwhelming it. This is a fragrance for the evening: for meditation, for winding down, for rooms that should feel warm and enclosed. The aroma settles deeply into a space and lasts long after the stick has burned through. Supplied in our box format, Oudh Dhoop Sticks are an easy way to bring a genuinely luxurious note into daily ritual.",

    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Oudh Dhoop Sticks - Uplifting Floral Delight",
    meta_description:"Oudh dhoop sticks, 100g at ₹55. The dark, resinous depth of agarwood, the most prized wood in traditional perfumery. Bamboo-free and charcoal-free.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/oudh_jar.jpg",
        url_l: "../assets/nt/oudh_jar.jpg",
      }
    ],
  },

  {
    id: 17,
    product_name: "Lavender",
    category: "dhoop-sticks",
    product_name_key:"Lavender",
    product_img: "../assets/nt/lavender.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "85",
    description:"Lavender Fragrance Dhoop Sticks are your gateway to tranquility, offering the soothing and calming essence of lavender in every burn. Lavender, known for its stress-relieving properties, has been a staple in aromatherapy for centuries, valued for its ability to calm the mind and body. Our dhoop sticks are meticulously crafted with natural ingredients, ensuring a pure and long-lasting fragrance that gently infuses your space with peace and serenity. As the lavender scent fills your home, it creates a tranquil atmosphere that helps you unwind and relax, making it ideal for use before bedtime, during meditation, or whenever you need a moment of calm. The gentle, floral aroma of lavender not only soothes the senses but also purifies the environment, making these dhoop sticks a perfect addition to your daily rituals. Embrace the calming power of lavender with these premium dhoop sticks and transform your space into a sanctuary of peace and relaxation.",
    weight: "200",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Lavender Dhoop Sticks - Uplifting Floral Delight",
    meta_description:"Lavender dhoop sticks, 200g at ₹55. Calming herbal lavender for winding down and settling a room at the end of the day. Bamboo-free, charcoal-free.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/lavender.jpg",
        url_l: "../assets/nt/lavender.jpg",
      }
    ],
  },
  {
    id: 18,
    product_name: "Rajnigandha",
    category: "dhoop-sticks",
    product_name_key:"Rajnigandha",
    product_img: "../assets/nt/rajnigandha.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Rajnigandha Fragrance Dhoop Sticks capture the creamy, night-blooming sweetness of tuberose, the flower that gives this fragrance its name. Rajnigandha opens after dark, and its aroma is famously rich - soft, full and unmistakably floral, a staple of Indian homes and temples alike. Our dhoop sticks are made from natural ingredients and burn evenly from end to end, releasing that heady white-floral character in a steady stream. The scent suits evening prayer, festive gatherings and any occasion that deserves something more generous than a light floral. Rajnigandha fills a room quickly and holds there, making it well suited to larger spaces. Let the lush aroma of rajnigandha bring a sense of celebration and quiet elegance to your home.",

    weight: "200",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Rajnigandha Dhoop Sticks - Uplifting Floral Delight",
    meta_description:"Rajnigandha dhoop sticks, 200g at ₹55. The creamy, night-blooming sweetness of tuberose. Bamboo-free and charcoal-free, made at our Indore factory.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/rajnigandha.jpg",
        url_l: "../assets/nt/rajnigandha.jpg",
      }
    ],
  },
  {
    id: 36,
    product_name: "Lavender Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Lavender_Cone",
    product_img: "../assets/nt/cone-lavender.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Lavender Dhoop Cones bring the calming, faintly herbal sweetness of lavender into a shape made for shorter sittings. Lavender is the fragrance people reach for to slow down — it has been used to settle nerves and quiet a room for as long as it has been grown — and the cone concentrates that effect rather than stretching it out. Light one twenty minutes before bed, or when a room has been busy all day and needs emptying out. As a cone it releases faster than a stick of the same weight, so the calm arrives sooner. Bamboo-free and charcoal-free, in a resealable 100g jar. Stand the cone on a metal plate or ceramic holder before lighting.",
    weight: "100",
    meta_title:"Lavender Dhoop Cones 100g Jar - Calming Herbal | NT Sticks",
    meta_description:"Lavender dhoop cones in a resealable 100g jar, ₹55. Calming herbal lavender in a fast-releasing cone. Bamboo-free, charcoal-free, made in Indore.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-lavender.jpg",
        url_l: "../assets/nt/cone-lavender.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 37,
    product_name: "Amber Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Amber_Cone",
    product_img: "../assets/nt/cone-amber.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Amber Dhoop Cones carry the warm, resinous sweetness that sits underneath so much Indian and Middle Eastern perfumery — honeyed and slightly powdery, with a depth closer to resin than to flowers. Amber is a fragrance that rewards concentration, which is exactly what the cone shape provides: pressed dense, it reads fuller and rounder than the same paste drawn out along a stick. It suits evenings, colder months and rooms with soft furnishing that hold onto scent. Bamboo-free and charcoal-free, so nothing sharp cuts across the warmth. Supplied in a resealable 100g jar. Burn on a metal plate or ceramic holder — the base gets hot as it works down.",
    weight: "100",
    meta_title:"Amber Dhoop Cones 100g Jar - Warm Resinous Amber | NT Sticks",
    meta_description:"Amber dhoop cones in a resealable 100g jar, ₹55. Warm, honeyed, resinous amber in a denser cone. Bamboo-free and charcoal-free, factory direct.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-amber.jpg",
        url_l: "../assets/nt/cone-amber.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 38,
    product_name: "Rose Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Rose_Cone",
    product_img: "../assets/nt/cone-rose.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Rose Dhoop Cones hold the full, romantic character of rose — the deep red flower rather than the cooler white, sweet and unmistakable, the scent Indian devotion and hospitality have leaned on for centuries. Rose can turn thin when it burns too slowly, which is where the cone helps: the denser shape keeps the fragrance whole and gives it real presence in the first few minutes. Good for prayer, for a room before guests arrive, and for anyone who wants a floral with some weight to it. Bamboo-free and charcoal-free, in a resealable 100g jar. Always burn on a metal plate or ceramic holder.",
    weight: "100",
    meta_title:"Rose Dhoop Cones 100g Jar - Rich Floral Rose | NT Sticks",
    meta_description:"Rose dhoop cones in a resealable 100g jar, ₹55. Full, romantic rose with real presence. Bamboo-free, charcoal-free, made at our Indore factory.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-rose.jpg",
        url_l: "../assets/nt/cone-rose.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 39,
    product_name: "Muskan Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Muskan_Cone",
    product_img: "../assets/nt/cone-muskan.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Muskan Dhoop Cones bring our brightest floral blend into a format made for everyday use. 'Muskan' means smile in Hindi, and the fragrance is exactly that — fresh, cheerful, easy to live with, and never heavy enough to tire of. As a cone it works well for resetting a room quickly: after cooking, before guests, at the end of a working day. The paste is identical to our Muskan dhoop sticks, just pressed denser, so you get the same aroma arriving faster. Bamboo-free and charcoal-free, which is what keeps the smoke light and the ash pale. Set the cone on a metal plate or ceramic holder before lighting.",
    weight: "100",
    meta_title:"Muskan Dhoop Cones 100g Jar - Bright Floral Dhoop | NT Sticks",
    meta_description:"Muskan dhoop cones in a resealable 100g jar, ₹55. A cheerful everyday floral that resets a room fast. Bamboo-free, charcoal-free, made in Indore.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-muskan.jpg",
        url_l: "../assets/nt/cone-muskan.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 40,
    product_name: "Ruh Heena Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Ruh_Heena_Cone",
    product_img: "../assets/nt/cone-ruh-heena.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Ruh Heena Dhoop Cones carry the earthy, green sweetness of henna — mehandi — a scent tied in India to weddings, festivals and the days of preparation before them. It is more herbal than floral, with a cool, slightly bitter edge that keeps it from ever feeling sugary. The cone shape suits it: henna is a quiet fragrance on a stick, and concentrating it gives the aroma enough body to hold a room. Traditional without being ceremonial, which makes it an easy everyday choice. Bamboo-free and charcoal-free, in a resealable 100g jar. Burn on a metal plate or ceramic holder.",
    weight: "100",
    meta_title:"Ruh Heena Dhoop Cones 100g Jar - Earthy Mehandi | NT Sticks",
    meta_description:"Ruh Heena dhoop cones in a resealable 100g jar, ₹55. Earthy, green henna aroma in a denser cone. Bamboo-free and charcoal-free, factory direct.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-ruh-heena.jpg",
        url_l: "../assets/nt/cone-ruh-heena.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 41,
    product_name: "Sandal Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Sandal_Cone",
    product_img: "../assets/nt/cone-sandal.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Sandal Dhoop Cones carry the creamy, grounding aroma of sandalwood in a shape built for shorter sittings. Sandalwood has anchored Indian prayer and meditation for centuries because it settles the mind rather than demanding attention, and the cone form suits that: the same paste as our sandal dhoop sticks, pressed denser, so it gives up its fragrance faster and fills a room in minutes instead of building slowly. Light one at the start of morning puja and it will have done its work by the time you finish. Bamboo-free and charcoal-free, so nothing sharpens the wood underneath. Stand the cone on a metal plate or a ceramic holder — the base gets hot as it burns down.",
    weight: "100",
    meta_title:"Sandal Dhoop Cones 100g Jar - Sacred Sandalwood | NT Sticks",
    meta_description:"Sandal dhoop cones in a resealable 100g jar, ₹55. Creamy sandalwood in a denser, faster-releasing cone. Bamboo-free, charcoal-free, made in Indore.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-sandal.jpg",
        url_l: "../assets/nt/cone-sandal.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 42,
    product_name: "Mogra Super Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Mogra_Super_Cone",
    product_img: "../assets/nt/cone-mogra-super.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Mogra Super Dhoop Cones deliver the sweet, heady aroma of mogra — the Indian jasmine sambac whose scent defines summer evenings across the country — in our premium grade. Mogra is a big fragrance, and the cone gives it somewhere to go: pressed dense, it arrives at full strength in the first minutes rather than building slowly, which is how the flower itself behaves at dusk. Best in larger rooms, courtyards and open doorways, where its carry is an advantage rather than too much. Bamboo-free and charcoal-free, in a resealable 100g jar. Burn on a metal plate or ceramic holder, never straight onto a surface.",
    weight: "100",
    meta_title:"Mogra Super Dhoop Cones 100g Jar - Premium Jasmine | NT Sticks",
    meta_description:"Mogra Super dhoop cones in a resealable 100g jar, ₹55. Sweet, heady Indian jasmine at premium grade. Bamboo-free and charcoal-free, made in Indore.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-mogra-super.jpg",
        url_l: "../assets/nt/cone-mogra-super.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 43,
    product_name: "Good Morning Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Good_Morning_Cone",
    product_img: "../assets/nt/cone-good-morning.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Good Morning Dhoop Cones are blended for the start of the day rather than the end of it — brighter and cleaner than our resins and heavy florals, with a fresh lift that wakes a room instead of settling it. It is the one to light while the house is coming awake, alongside the first puja of the morning, or to clear the night out of a closed bedroom. The cone format matches that job precisely: quick to catch, quick to fill a space, finished by the time breakfast is. Bamboo-free and charcoal-free, in a resealable 100g jar. Stand it on a metal plate or ceramic holder before lighting.",
    weight: "100",
    meta_title:"Good Morning Dhoop Cones 100g Jar - Fresh Morning Blend | NT Sticks",
    meta_description:"Good Morning dhoop cones in a resealable 100g jar, ₹55. A bright, clean blend made for morning puja. Bamboo-free, charcoal-free, factory direct.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-good-morning.jpg",
        url_l: "../assets/nt/cone-good-morning.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 44,
    product_name: "Pineapple Dhoop Cone",
    category: "dhoop-cone",
    product_name_key:"Pineapple_Cone",
    product_img: "../assets/nt/cone-pineapple.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Pineapple Dhoop Cones are the outlier in our range and deliberately so — sweet, juicy and tropical where almost everything else is floral or resinous. It is not a temple fragrance and does not pretend to be. This is the one for living rooms, children's rooms, shops and anywhere you want a room to feel bright and welcoming rather than devotional. The cone shape carries fruit well: concentrated, the sweetness stays vivid instead of thinning out the way it can on a slow-burning stick. Bamboo-free and charcoal-free, in a resealable 100g jar. Burn on a metal plate or ceramic holder.",
    weight: "100",
    meta_title:"Pineapple Dhoop Cones 100g Jar - Sweet Tropical | NT Sticks",
    meta_description:"Pineapple dhoop cones in a resealable 100g jar, ₹55. Bright, juicy tropical sweetness for living rooms and shops. Bamboo-free and charcoal-free.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/cone-pineapple.jpg",
        url_l: "../assets/nt/cone-pineapple.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/dhoop-cone-jar.jpg",
        url_l: "../assets/nt/dhoop-cone-jar.jpg",
      },
    ],
  },
  {
    id: 34,
    product_name: "Hawan Cups Box - Black",
    category: "sambrani-cup",
    product_name_key:"Sambrani_Cups_Black_Box",
    product_img: "../assets/nt/sambrani-cups-black-box.jpg",
    price: "100",
    mainPrice: "120",
    description:
      "A box of twelve ready-to-light sambrani cups, each one packed with benzoin resin and natural fragrance. There is no loose charcoal to light first, no kandi and no tongs - hold a flame to the rim for a few seconds and the cup catches on its own, then smoulders down to ash. What you get is the thick, sweet-resinous smoke traditionally used for havan and hom, for drying and scenting hair after a wash, and for clearing a room before prayer. These cups are high on smoke, so light one at a time and give the room some air. Always place the cup on a stand or a metal plate before lighting it: the cup burns through completely and gets hot enough underneath to damage whatever it is sitting on. Keep it away from anything that catches fire, and out of reach of children while it burns.",
    meta_title:"Sambrani Cups Box of 12 - Ready-to-Light Hawan Cups | NT Sticks",
    meta_description:"Box of 12 ready-to-light sambrani cups, ₹100 (MRP ₹120). No charcoal or kandi needed - light the cup itself. Made at our Indore factory.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/sambrani-cups-black-box.jpg",
        url_l: "../assets/nt/sambrani-cups-black-box.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/sambrani-cup-lighting.jpg",
        url_l: "../assets/nt/sambrani-cup-lighting.jpg",
      },
      {
        id: 2,
        url_s: "../assets/nt/sambrani-cup-precautions.jpg",
        url_l: "../assets/nt/sambrani-cup-precautions.jpg",
      },
    ],
  },
  {
    id: 35,
    product_name: "Hawan Cups Box - Cow Dung",
    category: "sambrani-cup",
    product_name_key:"Sambrani_Cups_Cowdung_Box",
    product_img: "../assets/nt/sambrani-cups-cowdung-box.jpg",
    price: "100",
    mainPrice: "120",
    description:
      "A box of twelve sambrani cups pressed from cow dung rather than charcoal - the material Indian households have used for havan for generations, and the reason this version burns with a softer, earthier smoke than the black cups. Each cup is filled with benzoin resin and natural fragrance, and lights on its own: touch a flame to the rim, wait a few seconds, and it takes. No loose charcoal, no kandi, no tongs. Cow dung is a traditional choice for hom and havan for its purifying associations, and it suits daily use where the black cups can feel heavy. Always set the cup on a stand or a metal plate before lighting - it burns through completely and the base gets hot enough to mark a surface. Keep it clear of anything flammable and away from children while it is alight.",
    meta_title:"Cow Dung Sambrani Cups Box of 12 - Havan Cups | NT Sticks",
    meta_description:"Box of 12 cow dung sambrani cups, ₹100 (MRP ₹120). Traditional havan cups that light without charcoal or kandi. Factory direct from Indore.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/sambrani-cups-cowdung-box.jpg",
        url_l: "../assets/nt/sambrani-cups-cowdung-box.jpg",
      },
      {
        id: 1,
        url_s: "../assets/nt/sambrani-cup-lighting.jpg",
        url_l: "../assets/nt/sambrani-cup-lighting.jpg",
      },
      {
        id: 2,
        url_s: "../assets/nt/sambrani-cup-precautions.jpg",
        url_l: "../assets/nt/sambrani-cup-precautions.jpg",
      },
    ],
  },
];

export const more_products = [
 
  {
    id: 19,
    product_name: "Muskan Box",
    category: "dhoop-sticks",
    product_name_key:"Muskan_Box",
    product_img: "../assets/nt/muskanmock.webp",
    price: "300",
    mainPrice: "350",
    description:
      "Muskan Fragrance Dhoop Sticks in our box format offer the same bright, uplifting floral blend in a larger quantity for regular use. 'Muskan' means smile in Hindi, and the fragrance is built around that idea - fresh, cheerful and easy to live with day after day. Each stick is made from natural ingredients and pressed to burn steadily, releasing a clean floral aroma that brightens a room without dominating it. The box holds enough for weeks of daily lighting, which makes it the sensible choice for households that burn dhoop every morning. Use it to open the day, to freshen a room before guests arrive, or as a gentle accompaniment to prayer. Muskan Dhoop Sticks are an uncomplicated everyday pleasure.",

    weight: "1000",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Muskan Dhoop Sticks 1kg Box - Bulk Floral Dhoop",
    meta_description:"Muskan dhoop sticks in a 1kg box - the value pack for households that burn dhoop daily, or for reselling. Bamboo-free and charcoal-free.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/muskanmock.webp",
        url_l: "../assets/nt/muskanmock.webp",
      }
    ],
  },
  {
    id: 20,
    product_name: "Mogra Super",
    category: "dhoop-sticks",
    product_name_key:"Mogra_Super",
    product_img: "../assets/nt/mogra_super.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "85",
    description:
      "Mogra Super Fragrance Dhoop Sticks deliver the sweet, heady aroma of mogra - the Indian jasmine sambac whose scent defines summer evenings across the country. This is our premium grade of the fragrance, blended for a fuller and longer-lasting floral character. Made from natural ingredients and pressed for a slow, even burn, each stick releases the warmth of jasmine in full without the sharpness that lesser blends can carry. Mogra is a favourite for prayer rooms, for welcoming guests, and for evenings when a room should smell alive. The aroma builds gently and lingers long after burning. Whether it is part of your daily puja or simply how your home smells at dusk, Mogra Super Dhoop Sticks bring one of India's best-loved fragrances at its best.",

    weight: "200",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Mogra Super Dhoop Sticks - Uplifting Floral Delight",
    meta_description:"Mogra Super dhoop sticks, 200g at ₹55. Our premium grade of Indian jasmine sambac — sweet, heady and unmistakable. Bamboo-free and charcoal-free.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/mogra_super.jpg",
        url_l: "../assets/nt/mogra_super.jpg",
      },
      
    ],
  },

  {
    id: 21,
    product_name: "White Gulab Jar",
    category: "dhoop-sticks",
    product_name_key:"White_Gulab_Jar",
    product_img: "../assets/nt/white_gulab_jar.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "White Gulab Fragrance Dhoop Sticks carry the soft, powdery character of white rose - gentler and cooler than the deep red rose, with a delicate sweetness that never turns cloying. Rose has been central to Indian devotion and hospitality for centuries, and the white variety brings a quieter, more contemplative version of it. Our dhoop sticks are made from natural ingredients and burn evenly, releasing a smooth floral aroma that suits meditation, morning prayer and calm domestic moments. The resealable jar keeps the sticks fresh between uses. This is a restrained fragrance, ideal for smaller rooms or for anyone who finds heavier florals overpowering. Let the gentle aroma of white gulab bring softness and quiet grace to your space.",

    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"White Gulab Dhoop Sticks - Uplifting Floral Delight",
    meta_description:"White Gulab dhoop sticks, 100g jar at ₹55. Cool, powdery white rose — gentler than red rose and never cloying. Bamboo-free and charcoal-free.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/white_gulab_jar.jpg",
        url_l: "../assets/nt/white_gulab_jar.jpg",
      }
    ],
  },
  {
    id: 23,
    product_name: "Chameli Jar",
    category: "dhoop-sticks",
    product_name_key:"Chameli_Jar",
    product_img: "../assets/nt/chameli_jar.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Chameli Fragrance Dhoop Sticks bring the delicate sweetness of jasmine into your home, a scent woven through Indian gardens, temples and celebrations. Chameli is lighter and more transparent than heavier white florals - fresh at first, then settling into a soft, honeyed warmth. Our dhoop sticks are crafted from natural ingredients and burn cleanly and evenly, releasing the flower's character without harshness. The fragrance suits morning prayer, quiet evenings and everyday freshening alike, and its lightness makes it easy to burn often. The resealable jar keeps every stick protected between uses. Whether you are deepening a daily ritual or simply want your home to smell like a garden at dusk, Chameli Dhoop Sticks offer a gentle and familiar comfort.",

    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Chameli Jar - Uplifting Floral Delight",
    meta_description:"Chameli dhoop sticks, 100g jar at ₹55. Delicate jasmine, lighter and more transparent than heavier white florals. Bamboo-free, charcoal-free, factory direct.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/chameli_jar.jpg",
        url_l: "../assets/nt/chameli_jar.jpg",
      },
    ],
  },
  {
    id: 24,
    product_name: "Guggal Jar",
    category: "dhoop-sticks",
    product_name_key:"Guggal_Jar",
    product_img: "../assets/nt/guggal.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Guggal Fragrance Dhoop Sticks are built around guggal, the resin burned in Indian havan and puja for thousands of years. Its aroma is earthy and balsamic - woody, faintly sweet, and unmistakably ceremonial. Traditionally valued for purifying a space, guggal remains one of the most rooted fragrances in Indian ritual practice. Our dhoop sticks are made from natural ingredients and burn slowly and evenly, releasing the resin's full depth without the sharp smoke of loose material on charcoal. This makes them well suited to daily havan, meditation, or preparing a room before prayer. The scent is grounding rather than decorative, and it lingers with real presence. Let the ancient aroma of guggal bring a sense of purity and stillness to your home.",

    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Guggal Jar - Uplifting Floral Delight",
    meta_description:"Guggal dhoop sticks, 100g jar at ₹55. The earthy, balsamic resin burned in Indian havan and puja for centuries. Bamboo-free and charcoal-free.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/guggal.jpg",
        url_l: "../assets/nt/guggal.jpg",
      }
    ],
  },
  {
    id: 25,
    product_name: "Kewda",
    category: "dhoop-sticks",
    product_name_key:"Kewda",
    product_img: "../assets/nt/kewda.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    weight: "100",
    description:
      "Kewda Fragrance Dhoop Sticks bring the fresh and invigorating scent of the kewda flower into your home, creating an atmosphere of purity and tranquility. Kewda, known for its unique and uplifting fragrance, has been used in traditional rituals and spiritual practices for centuries. Our dhoop sticks are crafted from natural ingredients, ensuring a smooth and even burn that releases the full essence of kewda throughout your space. This refreshing floral scent is perfect for meditation, prayer, or simply enhancing the ambiance of your living environment. The aroma of kewda is known to rejuvenate the senses and uplift the spirit, making it ideal for creating a serene and peaceful atmosphere. Whether you are deepening your spiritual practice or seeking a moment of relaxation, Kewda Dhoop Sticks provide a sensory experience that connects you with the essence of nature and enhances your overall well-being.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Kewda Dhoop Sticks - Refreshing Floral Essence",
    meta_description:"Elevate your space with Kewda Dhoop Sticks, offering a refreshing and invigorating floral fragrance ideal for relaxation and spiritual practices.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/kewda.jpg",
        url_l: "../assets/nt/kewda.jpg",
      }
    ],
  },

  {
    id: 26,
    product_name: "Ruh Heena",
    category: "dhoop-sticks",
    product_name_key:"Ruh_Heena",
    product_img: "../assets/nt/jar/ruh-heena.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:"Ruh Heena Fragrance Dhoop Sticks capture the rich and earthy aroma of henna, also known as mehandi, offering an exotic fragrance that connects you with ancient traditions. Henna has been cherished for its aromatic and therapeutic properties, often used in spiritual rituals and ceremonies. Our dhoop sticks are made from natural ingredients, providing a long-lasting and consistent burn that releases the deep, warm scent of henna throughout your space. This grounding fragrance is ideal for meditation, relaxation, and creating a peaceful environment in your home. The aroma of Ruh Heena Dhoop Sticks evokes a sense of comfort and tranquility, making it perfect for enhancing your spiritual practices or simply unwinding after a busy day. Let the exotic fragrance of henna envelop your senses, bringing you closer to nature and enriching your spiritual journey.",
    weight: "100",
    meta_title:"Ruh Heena Dhoop Sticks - Exotic Henna Aroma",
    meta_description:"Immerse in the exotic scent of Ruh Heena Dhoop Sticks, offering a warm and earthy fragrance perfect for spiritual and relaxation practices.",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/ruh-heena.jpg",
        url_l: "../assets/nt/ruh-heena.jpg",
      }
    ],
  },

  {
    id: 27,
    product_name: "Muskan",
    category: "dhoop-sticks",
    product_name_key:"Muskan",
    product_img: "../assets/nt/jar/5.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:"Muskan Fragrance Dhoop Sticks are designed to bring joy and positivity into your life with their uplifting floral aroma. 'Muskan' means smile in Hindi, and these dhoop sticks truly live up to their name by filling your space with a delightful fragrance that brightens the atmosphere and lifts your spirits. Made from natural ingredients, these dhoop sticks burn evenly and consistently, releasing a vibrant and cheerful scent that can enhance any room. The fresh floral aroma of Muskan is perfect for starting your day on a positive note, for use during meditation, or for creating a warm and welcoming environment for guests. Whether you're looking to boost your mood or simply enjoy the beauty of this delightful fragrance, Muskan Dhoop Sticks offer a sensory experience that brings happiness and serenity to your home.",
    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Muskan Dhoop Sticks 100g - Everyday Floral Dhoop",
    meta_description:"Muskan dhoop sticks, 100g. A cheerful floral fragrance for daily puja, made without bamboo or charcoal at our own factory in Indore.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/jar/5.jpg",
        url_l: "../assets/nt/jar/5.jpg",
      }
     
    ],
  },
  {
    id: 28,
    product_name: "Firangipani box",
    category: "dhoop-sticks",
    product_name_key:"Firangipani_box",
    product_img: "../assets/nt/mockups/fp.webp",
    price: "10",
    mainPrice: "15",
    description:
      "Firangipani Fragrance Dhoop Sticks capture the creamy tropical sweetness of frangipani, the flower known across India as champa. Its scent is soft and full - floral with a warm, almost fruity roundness that feels immediately calming. Our dhoop sticks are made from natural ingredients and pressed for a slow, even burn, releasing the flower's character steadily rather than in a rush. Frangipani suits relaxed evenings, meditation and any space that should feel warm and unhurried. It is a gentler alternative to sharper florals, and it holds in a room for a long time after burning. Supplied in our box format for regular use, Firangipani Dhoop Sticks bring a soft tropical calm to daily life.",

    weight: "50",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Firangipani Dhoop Sticks - Exotic Floral Bliss",
    meta_description:"Immerse in the exotic fragrance of Firangipani Dhoop Sticks, a floral delight that enhances relaxation and spiritual ambiance.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/mockups/fp.webp",
        url_l: "../assets/nt/mockups/fp.webp",
      }
     
    ],
  },

  {
    id: 29,
    product_name: "Rose Zipper",
    category: "incense-sticks",
    product_name_key:"Rose_Zipper",
    product_img: "../assets/nt/3.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "85",
    description:"Rose Fragrance Incense Sticks bring the timeless scent of roses into your living spaces. Rolled on a thin bamboo core and hand-dipped in our rose perfume oil, these are agarbatti in the format most Indian homes know - quick to light, roughly thirty minutes of burn, and enough carry to scent a full room rather than just the corner it stands in. The aroma is rich without turning heavy: recognisably fresh rose, the flower that has meant love and serenity here for centuries. Light one for morning puja, before guests arrive, or simply to reset a room at the end of a long day. The resealable zipper pouch keeps the remaining sticks fresh and takes up almost no shelf space, so a pack lasts as long as the fragrance does.",
    weight: "200",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Rose Incense Sticks - Luxurious Floral Agarbatti",
    meta_description:"Rose incense sticks in a resealable zipper pouch. A rich, romantic floral agarbatti for daily puja, meditation and unhurried evenings at home.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/3.jpg",
        url_l: "../assets/nt/3.jpg",
      }
    ],
  },
  {
    id: 30,
    product_name: "Muskaan Zipper",
    category: "incense-sticks",
    product_name_key:"Muskaan_Zipper",
    product_img: "../assets/nt/4.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:
      "Muskaan Fragrance Incense Sticks bring our brightest floral blend in the format most Indian homes reach for first. 'Muskaan' means smile in Hindi, and the fragrance is exactly that - fresh, cheerful and easy to live with. Each agarbatti is rolled on a thin bamboo core, hand-dipped in natural perfume oils and burns evenly for around half an hour, releasing a clear floral aroma that lifts a room without weighing it down. The resealable zipper pouch keeps the sticks fresh, takes up little space and travels well, which makes it a practical choice for smaller homes, hostels, or keeping a pack at work. Light one to start the morning, to reset a room, or simply to enjoy a familiar comfort.",

    weight: "200",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Muskaan Incense Sticks - Uplifting Floral Agarbatti",
    meta_description:"Muskaan incense sticks in a resealable zipper pouch. A bright, cheerful floral agarbatti for everyday puja - light, fresh and easy to live with.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/4.jpg",
        url_l: "../assets/nt/4.jpg",
      }
    ],
  },
  {
    id: 31,
    product_name: "3 in 1 Zipper",
    category: "incense-sticks",
    product_name_key:"3_in_1_Zipper",
    product_img: "../assets/nt/5.jpg",
    price: "55",
    boxPrice: "280",
    mainPrice: "85",
    description:
      "Our 3 in 1 Zipper pack brings together three of our fragrances in a single resealable pouch, so you can change the mood of a room without committing to a full pack of any one scent. Every incense stick is rolled on a thin bamboo core and hand-dipped in the same natural perfume oils as our single-fragrance range, with the same even thirty-minute burn. The variety makes this an easy starting point if you are new to agarbatti and unsure which family suits you, and it is equally useful for households that prefer one fragrance for morning prayer and another in the evening. The zipper pouch keeps every stick fresh between uses and stores neatly. Whether you are exploring or simply like having options, the 3 in 1 pack is the most flexible way to keep incense in the house.",

    weight: "200",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"3 in 1 Incense Sticks - Three Fragrances, One Zipper Pouch",
    meta_description:"Three of our fragrances in a single resealable pouch. The easiest way to try our incense sticks, or to keep a different scent for morning and evening.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/5.jpg",
        url_l: "../assets/nt/5.jpg",
      }
    ],
  },
  {
    id: 32,
    product_name: "Super Mogra box",
    category: "dhoop-sticks",
    product_name_key:"Super_Mogra_box",
    product_img: "../assets/nt/sm_box.webp",
    price: "10",
    mainPrice: "15",
    description:
      "Super Mogra Fragrance Dhoop Sticks bring our premium jasmine sambac blend in a larger box format for households that burn it daily. Mogra is one of India's most loved fragrances - sweet, heady and full, the scent of summer evenings and temple courtyards. This grade is blended for a richer and longer-lasting floral character. Made from natural ingredients and pressed for a slow, even burn, each stick releases the flower's warmth in full, holding in a room long after it has finished. It suits prayer, gatherings and any occasion when a home should smell generous rather than subtle. The box holds enough for weeks of regular use. Super Mogra Dhoop Sticks are a staple fragrance, supplied at the quantity a daily ritual actually needs.",

    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Super Mogra Dhoop Sticks - Uplifting Floral Delight",
    meta_description:"Super Mogra dhoop sticks, 100g box at ₹10. Our premium jasmine sambac blend in the small everyday box. Bamboo-free and charcoal-free, made in Indore.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/sm_box.webp",
        url_l: "../assets/nt/sm_box.webp",
      }
    ],
  },
  {
    // Was 13, which collided with Hawan Jar. The cart matches lines by id, so
    // the two products merged into one line — adding both gave you two of the
    // first and silently dropped the second. 11 was the one unused id.
    id: 11,
    product_name: "Loban Jar",
    category: "dhoop-sticks",
    product_name_key:"Loban_Jar",
    product_img: "../assets/nt/jar/4.jpeg",
    price: "55",
    boxPrice: "280",
    mainPrice: "80",
    description:"Loban Fragrance Dhoop Sticks bring the ancient purifying aroma of loban, a resin derived from the Styrax tree, into your living spaces. Known for its grounding and cleansing properties, loban has been used in traditional rituals for centuries to purify the environment and promote tranquility. Our dhoop sticks are crafted with precision, ensuring an even burn that releases the rich, balsamic scent of loban throughout your home. This soothing aroma not only purifies the air but also creates a peaceful atmosphere, making it ideal for meditation, yoga, or simply unwinding after a long day. Whether you’re looking to cleanse your space of negative energy or enhance your spiritual practices, Loban Dhoop Sticks provide a sensory experience that calms the mind and uplifts the spirit. Let the sacred fragrance of loban transform your home into a sanctuary of peace and relaxation.",

    weight: "100",
    stars: Array(5).fill(
      <small className="fa fa-star text-primary mr-1"></small>
    ),
    ratingCount: 99,
    meta_title:"Loban Dhoop Sticks - Purify & Soothe Your Space",
    meta_description:"Purify your home with Loban Dhoop Sticks, offering a grounding and soothing fragrance ideal for meditation and spiritual cleansing.",
    gallery: [
      {
        id: 0,
        url_s: "../assets/nt/jar/4.jpeg",
        url_l: "../assets/nt/jar/4.jpeg",
      }
      
    ],
  }

];

export const features = [
  {
    id: 0,
    // icon: <h1 style={{color:"#48e148 !important"}} className="fa fa-phone-volume text-primary m-0 mr-3 dark-greeen"></h1>,
    icon:<img className="cod-style" src="../assets/nt/cod.webp" alt="Cash on delivery available"></img>,
    title: "Pay On Delivery",
  },
  {
    id: 1,
    icon: <h1 className="fa fa-check text-primary m-0 mr-3 dark-greeen"></h1>,
    title: "Quality Products",
  },
  {
    id: 2,
    icon: <h1 style={{color:"#48e148 !important"}} className="fa fa-shipping-fast text-primary m-0 mr-2 dark-greeen"></h1>,
    title: "Free Shipping",
  },
  {
    id: 3,
    icon: <h1 style={{color:"#48e148 !important"}} className="fas fa-exchange-alt text-primary m-0 mr-3 dark-greeen"></h1>,
    title: "7-Days Return",
  },
  // {
  //   id: 4,
  //   icon: <h1 style={{color:"#48e148 !important"}} className="fa fa-phone-volume text-primary m-0 mr-3 dark-greeen"></h1>,
  //   title: "24/7 Customer Support",
  // },
  
];

export const vendors = [
  {
    image: "../assets/img/vendor-1.jpg",
  },
  {
    image: "../assets/img/vendor-2.jpg",
  },
  {
    image: "../assets/img/vendor-3.jpg",
  },
  {
    image: "../assets/img/vendor-4.jpg",
  },
  {
    image: "../assets/img/vendor-5.jpg",
  },
  {
    image: "../assets/img/vendor-6.jpg",
  },
  {
    image: "../assets/img/vendor-7.jpg",
  },
  {
    image: "../assets/img/vendor-8.jpg",
  },
];

export const carousel = [
  GANESH_SEASON_ENABLED
    ? {
        cover_img: "../assets/nt/ganesh12.jpg",
        cover_img_mobile: "../assets/nt/ganesh.jpg",
        title: "",
        description:
          "Experience the season’s most eco-friendly Ganesh offerings, hand-crafted for mindful celebrations.",
        btn: "Shop Now",
      }
    : DIWALI_SEASON_ENABLED
    ? {
        cover_img: "../assets/nt/diwali-complete-kit.jpg",
        cover_img_mobile: "../assets/nt/diwali-complete-kit.jpg",
        title: "",
        description:
          "Celebrate with premium fragrance kits and ritual essentials built for Diwali gifting and home ceremonies.",
        btn: "Shop Now",
      }
    : {
        cover_img: "../assets/nt/cups_banner.jpg",
        cover_img_mobile: "../assets/nt/hawan_cups_banner.jpg",
        title: "",
        description:
          "Premium natural aroma curated for everyday rituals.",
        btn: "Shop Now",
      },
  // {
  //   cover_img: "../assets/nt/carousel-2.jpg",
  //   title: "",
  //   description:
  //     "Lorem rebum magna amet lorem magna erat diam stet. Sadips duo stet amet amet ndiam elitr ipsum diam",
  //   btn: "Shop Now",
  // },
  // {
  //   cover_img: "../assets/img/carousel-3.jpg",
  //   title: "",
  //   description:
  //     "Lorem rebum magna amet lorem magna erat diam stet. Sadips duo stet amet amet ndiam elitr ipsum diam",
  //   btn: "Shop Now",
  // },
];

export const footerTouch = [
  {
    icon: <i className="fa fa-map-marker-alt text-primary mr-3"></i>,
    contact: "718, Loha Mandi, Panchshil Nagar, Indore, Madhya Pradesh 452001",
    type:"address"
  },
  {
    icon: <i className="fa fa-envelope text-primary mr-3"></i>,
    contact: "ntincensesticks@gmail.com",
    type:"email"
  },
  {
    icon: <i className="fa fa-phone-alt text-primary mr-3"></i>,
    contact: "6264208349",
    type:"call"
  },
];

export const footer = [
  {
    id: 1,
    header: "Quick Shop",
  },
  {
    id: 2,
    header: "My Account",
  },
];
export const product_benifits = [
  {
    id:1,
    image: "../assets/nt/product.webp",
    name: "Free Delivery",
  },
  {
    id:2,
    image: "../assets/nt/biodegradable.webp",
    name: "Eco Friendly",
  },
  // // {
  // //   id:3,
  // //   image: "../assets/nt/eco-paint.webp",
  // //   name: "Eco Paint",
  // // },
  {
    id:4,
    image: "../assets/nt/pottery.webp",
    name: "Pottery",
  },
  {
    id:5,
    image: "../assets/nt/growth.webp",
    name: "Growth",
  },
];

export const sidebar = [
  // {
  //   id: 1,
  //   header: "Filter By Price(in Rupees)",
  //   all: "All Price",
  //   total_quantity: "1000",
  //   subItem: [
  //     {
  //       variety: "0-100",
  //       quantity: "150",
  //     },
  //     {
  //       variety: "100-200",
  //       quantity: "150",
  //     },
  //     {
  //       variety: "200-300",
  //       quantity: "150",
  //     },
  //     {
  //       variety: "300-400",
  //       quantity: "150",
  //     },
  //     {
  //       variety: "400-500",
  //       quantity: "150",
  //     },
  //   ],
  // },
  {
    id: 1,
    header: "Filter By Fragrance",
    all: "All Fragrance",
    total_quantity: "1000",
    subItem: [
      {
        variety: "Rose",
        quantity: "30",
      },
      {
        variety: "Lavender",
        quantity: "11",
      },
      {
        variety: "Mogra",
        quantity: "20",
      },
      {
        variety: "Firangipani",
        quantity: "10",
      },
      {
        variety: "White Musk",
        quantity: "15",
      },
      {
        variety: "Pineapple",
        quantity: "15",
      },
      {
        variety: "Kewda",
        quantity: "15",
      },
      {
        variety: "Ruh Heena",
        quantity: "15",
      },
      {
        variety: "Muskan",
        quantity: "15",
      },
      {
        variety: "Loban",
        quantity: "15",
      },
      {
        variety: "Hawan",
        quantity: "15",
      },
      {
        variety: "Sandal",
        quantity: "15",
      },
    ],
  },
  // {
  //   id: 2,
  //   header: "Filter By Weight(in grams)",
  //   all: "All Weights",
  //   total_quantity: "1000",
  //   subItem: [
  //     {
  //       variety: "100",
  //       quantity: "60",
  //     },
  //     {
  //       variety: "200",
  //       quantity: "19",
  //     },
  //     {
  //       variety: "500",
  //       quantity: "150",
  //     },
  //     {
  //       variety: "1000",
  //       quantity: "16",
  //     },
  //     {
  //       variety: "2000",
  //       quantity: "15",
  //     },
  //   ],
  // },
];
